import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Typography, useTheme, Divider } from '@mui/material';

const Terms = () => {
    const theme = useTheme();

    return (
        <Box sx={{
            minHeight: '80vh',
            bgcolor: 'background.default',
            py: { xs: 8, md: 12 },
            position: 'relative',
            overflow: 'hidden'
        }}>
            <Helmet>
                <title>Terms of Service | WorldWise Scholar</title>
                <link rel="canonical" href="https://worldwisescholar.online/terms" />
            </Helmet>
            {/* Ambient Glows */}
            <Box sx={{
                position: 'absolute',
                bottom: '-10%',
                left: '-5%',
                width: '60%',
                height: '60%',
                background: `radial-gradient(circle, ${theme.palette.secondary.main}1A 0%, transparent 70%)`,
                zIndex: 0,
                pointerEvents: 'none',
            }} />

            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
                <Typography variant="h2" component="h1" gutterBottom fontWeight="900" sx={{
                    background: theme.palette.mode === 'light'
                        ? 'linear-gradient(to right, #111827, #4F46E5)'
                        : 'linear-gradient(to right, #F8FAFC, #A5B4FC)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 4
                }}>
                    Terms of Service
                </Typography>

                <Box sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        1. Acceptance of Terms
                    </Typography>
                    <Typography paragraph>
                        By accessing or using the WorldWise Scholar website, you agree to be bound by these Terms of Service. If you do not agree to all of these terms, do not use our website.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        2. Use of Services
                    </Typography>
                    <Typography paragraph>
                        You agree to use our services only for lawful purposes and in accordance with these Terms. You are responsible for maintaining the confidentiality of your account information.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        3. Intellectual Property
                    </Typography>
                    <Typography paragraph>
                        All content on our website, including text, graphics, logos, and software, is the property of WorldWise Scholar and is protected by intellectual property laws.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        4. Limitation of Liability
                    </Typography>
                    <Typography paragraph>
                        WorldWise Scholar shall not be liable for any direct, indirect, incidental, or consequential damages resulting from your use of our website or services.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        5. Changes to Terms
                    </Typography>
                    <Typography paragraph>
                        We reserve the right to modify these Terms of Service at any time. Your continued use of our website after such changes constitutes your acceptance of the new Terms.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Terms;
